import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import BackIcon from '@src/assets/icons/arrow_back.svg';
import ReactDOM from 'react-dom';
import { Button } from "../button";
import { Modal } from "./Modal";
import { BodyCaption, BodyPrimary, TitleMedium, } from "../TypographyStyle";
import { COLORS } from "../../constants/Theme";
const ModalWrapper = styled.div `
	display: flex;
	flex-direction: column;
	flex: 1;
	align-items: flex-start;
	overflow: hidden;
	max-width: 100%;
`;
const ModalHeader = styled.div `
	padding: 16px 24px;
	width: 100%;
	display: flex;
	flex-direction: row;
	gap: 12px;
	justify-content: center;
	background-color: ${(props) => props.tintedHeader ? COLORS.background.warning.light : 'transparent'};
	border-top-left-radius: ${(props) => (props.tintedHeader ? '4px' : 'none')};
`;
const ModalTitles = styled.div `
	display: flex;
	flex-direction: column;
`;
const ModalCustomisation = styled.div `
	display: flex;
	margin-left: auto;
	justify-content: flex-end;
	align-items: center;
`;
const ModalSubtitle = styled(BodyPrimary) `
	margin-top: 4px;
	color: ${COLORS.content.secondary} !important;
`;
const ModalFooter = styled.div `
	padding: 16px 24px;
	display: flex;
	align-items: center;
	justify-content: end;
	margin-top: auto;
	width: 100%;
`;
const ModalFooterRightCustomisation = styled.div `
	margin-right: auto;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: calc(100% - 32px);
`;
const ModalBody = styled.div `
	width: 100%;
	z-index: 1;
	box-shadow: ${(props) => props.showShadow ? 'inset 0 -3px 6px rgba(0, 0, 0, 0.12)' : 'none'};
`;
const SecondaryButtonWrapper = styled(Button) `
	margin-right: 8px;
`;
export const StyledModal = (props) => {
    var _a, _b, _c, _d, _e;
    if (typeof window === 'undefined')
        return null;
    return ReactDOM.createPortal(_jsx(Modal, Object.assign({ "data-test": props['data-test'], id: props.id, zIndex: props.zIndex, open: props.open, onClose: props.onClose, closeOnOutsideClick: props.closeOnOutsideClick, centralContainerStyles: props.centralContainerStyles, hideCrossButton: props.hideCrossButton, width: props.width }, { children: _jsxs(ModalWrapper, Object.assign({ style: (_a = props.wrapperStyle) !== null && _a !== void 0 ? _a : {}, id: props.innerModalId }, { children: [(props.headingTitle ||
                    props.headingSubtitle ||
                    props.headerRightCustomElement) && (_jsxs(ModalHeader, Object.assign({ style: (_b = props.modalHeaderStyles) !== null && _b !== void 0 ? _b : {}, tintedHeader: (_c = props.tintedHeader) !== null && _c !== void 0 ? _c : false }, { children: [props.onBackPress && (_jsx("div", Object.assign({ style: { cursor: 'pointer' }, onClick: (e) => {
                                props.onBackPress ? props.onBackPress() : e.stopPropagation();
                            } }, { children: _jsx(BackIcon, { width: 18, height: 18 }) }))), _jsxs("div", Object.assign({ style: { flex: 1 } }, { children: [_jsxs("div", Object.assign({ style: {
                                        display: 'flex',
                                        gap: '8px',
                                        alignItems: 'center',
                                    } }, { children: [_jsx(ModalTitles, { children: props.headingTitle && (_jsx(TitleMedium, { children: props.headingTitle })) }), props.isBeta && (_jsx("div", Object.assign({ style: {
                                                padding: '2px 8px',
                                                borderRadius: '16px',
                                                backgroundColor: '#1877f2',
                                                height: 'fit-content',
                                                width: 'fit-content',
                                            } }, { children: _jsx(BodyCaption, Object.assign({ style: { color: COLORS.surface.standard } }, { children: "BETA" })) }))), props.headerLeftCustomElement && props.headerLeftCustomElement] })), _jsx(ModalTitles, { children: props.headingSubtitle && (_jsx(ModalSubtitle, { children: props.headingSubtitle })) })] })), props.headerRightCustomElement && (_jsx(ModalCustomisation, { children: props.headerRightCustomElement }))] }))), props.children && (_jsx(ModalBody, Object.assign({ style: (_d = props.modalBodyStyles) !== null && _d !== void 0 ? _d : {}, showShadow: (_e = props.footerShadow) !== null && _e !== void 0 ? _e : false }, { children: props.children }))), (props.primaryButton ||
                    props.secondaryButton ||
                    props.footerLeftCustomElement) && (_jsxs(ModalFooter, Object.assign({ style: props.footerContainerStyle }, { children: [props.footerLeftCustomElement && (_jsx(ModalFooterRightCustomisation, { children: props.footerLeftCustomElement })), props.secondaryButton && (_jsx(SecondaryButtonWrapper, Object.assign({}, props.secondaryButton))), props.primaryButton && _jsx(Button, Object.assign({}, props.primaryButton))] })))] })) })), document.body);
};
//# sourceMappingURL=styledModal.js.map